import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Phone, ShieldAlert, Heart } from "lucide-react";
import api from "@/lib/api";

/** Read-only emergency contact card for the worker dashboard. */
export default function EmergencyContactCard() {
  const [info, setInfo] = useState(null);
  useEffect(() => { (async () => {
    try { setInfo((await api.get("/emergency-contacts")).data); } catch { /* ignore */ }
  })(); }, []);

  if (!info || !info.emergency_contact_name) return null;

  return (
    <Card className="rounded-3xl p-5 border-2 relative overflow-hidden" data-testid="emergency-card"
          style={{ background: "linear-gradient(135deg, hsl(var(--coral) / 0.10), hsl(var(--sun) / 0.10))", borderColor: "hsl(var(--coral) / 0.30)" }}>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-coral/15 grid place-items-center text-coral shrink-0"><ShieldAlert className="w-5 h-5" strokeWidth={2.6} /></div>
        <div className="flex-1 min-w-0">
          <div className="text-xs uppercase tracking-wider font-bold text-coral">Emergency contact for {info.client_name}</div>
          <div className="font-display font-extrabold text-xl mt-0.5" data-testid="ec-name">{info.emergency_contact_name}</div>
          <div className="text-sm text-muted-foreground">{info.emergency_contact_relationship}</div>
          <a href={`tel:${(info.emergency_contact_phone || '').replace(/\s+/g, '')}`}
             data-testid="ec-phone-link"
             className="inline-flex items-center gap-1.5 mt-2 rounded-full bg-coral text-white font-bold text-sm px-3 py-1.5">
            <Phone className="w-3.5 h-3.5" /> {info.emergency_contact_phone}
          </a>
          {info.emergency_medical_info && (
            <div className="mt-3 rounded-xl bg-card p-2.5 border text-sm" data-testid="ec-med">
              <div className="text-[10px] uppercase tracking-wider font-bold text-muted-foreground flex items-center gap-1"><Heart className="w-3 h-3 text-coral" /> Medical info</div>
              <div className="font-semibold mt-0.5">{info.emergency_medical_info}</div>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
